/**

@ngdoc directive
@name addressFinder

@description
Address fields with autocomplete

@usage
    <address-finder
    	label="Working address"			                        // label for the whole field
    	prefix-name="prefix" 			                        // fields name prefix (output example: input name="prefix.line_1" ... )
        bottom-button-shelf                                     // provide room below the widget to place buttons. This allows for additional external functionality whilst appearing to be part of the widget
    	ng-required="true"				                        // required
        ng-model="yourModel"
        hide-search="true"                                      // (optional, false by default) hides search field and display address fields by default
        hide-address-labels="true"                              // (optional, false by default) hides address labels
    	ng-init="yourModel={line_1:'test',town:'London'}"	    // (optional) init values
        validation-warnings                                     // (optional) 'required' or 'blank' (either)
        warning-messages                                        // (optional) warning validation messages
        address-tooltip="Toolitp text"                          // (optional)
        single-input="true"                                     // (optional) uses new poc single input search for the address line X3-19209
        mandatory-field-map="{[fieldTitle: string]: boolean}"   // (optional) provides configuration to set individual inputs as required only when not using address lookup. Please note field title should be inputted without space e.g. line1
	></address-finder>
*/

(function() {
  'use strict';

var addressFinder = function ($timeout, $templateCache, $http) {
    return {
        restrict: "EA",
        scope: {
            label:"@",
            bottomButtonShelf: "=",
            isBusiness:"=?",
            prefixName: '@', // fields prefix
            singleInput: "=?",
            ngRequired: "=?",
            ngReadonly: "=?",
            ngDisabled: "=?",
            hideSearch: "&", // false by default
            hideAddressLabels: "=?", // false by default
            initAddress: "&",
            addressTooltip: "@",
            hasWarning: '@validationWarnings',
            warningMessages: "&",
            ngModel: "=",
            countryList: "=",
            autocompletePostUrl: "@",
            autocompletePreUrl: "@",
            mandatoryFieldMap: "=",
            textfieldCountry: "=?"
        },
        priority:200, // TODO: remove priority ?
        replace: true,
        transclude: false,
        template: $templateCache.get("formWidget/addressFinder.html"),
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

            this.$onInit = function(){
                $scope.model = {};
                $scope.ngModel = {};
            	$scope.showWidget = false;
            	$scope.autocompleteUrl = '/rest/address/lookup?';
            	if (angular.isDefined($scope.autocompletePreUrl) && $scope.autocompletePreUrl !== "") {
            	  $scope.autocompleteUrl = $scope.autocompletePreUrl;
            	}

                //show new widget logic
                $scope.singleInput = false;
                var baseUrl = WEBAPP_PATH ;
                console.log(WEBAPP_PATH);
                $http.get(baseUrl + '/rest/address/permission').then(
                    function(response){
                        $scope.singleInput = response.data.showNewAddressWidget;

                    });
                //


                $scope.addressLabels = {
                    line_1   : "Line 1",
                    line_2   : "Line 2",
                    town     : "Town",
                    county   : "County",
                    postCode : "Postcode",
                    country  : "Country"
                };

                $scope.pattern = new RegExp('^[a-zA-Z0-9À-ÖØ-öø-ÿ\u3131-\uD79D]{1}(.)*$') // X3-13908 option 1 - match diacritics and Korean characters
                // $scope.pattern = new RegExp("^[^\\\\'\".,-\\/#!$%\\^&\\*;:{}=\\-_`~()@\\+\\?><\\[\\]\\+]{1}(.)*$") // X3-13908 option 2 - exclude all punctuation - I'm not sure that this is exhaustive

                if( angular.isDefined($scope.initAddress()) ) {
                    console.warn("Address Finder: init-address attribute has been deprecated - please use ng-init along with ng-model instead of that.");
                	$scope.ngModel = $scope.initAddress();
                	// $scope.showWidget = true; // no needed with the model watch
                }

                if(angular.isDefined($scope.hideSearch()) && $scope.hideSearch()) {
                    $scope.showWidget = true;
                }
            };

            $scope.postCodePattern = {};
            $scope.postCodePattern.code = /^[a-zA-Z0-9]{1}(.)*$/;
            $scope.postCodePattern.message = 'Field value can only start with number or letter.';

            /**
             * Function that will set post code validation pattern and message based on country ID
             * @param countryId
             */
            $scope.setPostCodePattern = function (countryId) {
                console.log('countryId', countryId);
                $scope.postCodePattern = {};
                const countryCodeIreland =  794;
               /* if (countryId == countryCodeIreland) {
                    $scope.postCodePattern.code = /^[0-9]*$/;
                    $scope.postCodePattern.message = 'Field value can only be numbers.';
                }else {*/
                    $scope.postCodePattern.code = /^[a-zA-Z0-9]{1}(.)*$/;
                    $scope.postCodePattern.message = 'Field value can only start with number or letter.';
               /* }*/
            };

            // validation message (TODO: translate service)
            $timeout(function(){
                if($scope.hasWarning=='required'){
                    $scope.msgRequired = 'The field should be filled in.';
                } else {
                    $scope.msgRequired = 'The field is required.';
                }

                if( angular.isDefined($scope.ngModel.id) ){
                    $scope.prevId = $scope.ngModel.id;
                }
            });

        }],
        require: '^form', // parent form binding
        link: function(scope, element, attrs, formCtrl) {

        	scope.form = formCtrl;

            // show the rest of the form if only ngModel is not empty
            var removeWatch1 = scope.$watch(
                function(){
                    return scope.ngModel;
                },
                function(newVal, oldVal){
                    if( Object.keys(newVal).length ){ // if not empty
                        scope.showWidget = true;
                        removeWatch1(); // once the the fields are shown we don't need to watch anymore
                    }
                }
            );


            scope.$watch(
                function(scope){
                    return scope.model.addressTypehead;
                },
                function( newVal, oldVal ) {
                    if(newVal != oldVal){
                        if(angular.isObject(newVal)) {
                            scope.ngModel = newVal;
                            delete scope.ngModel.id; // we don't want to use the id information (as per spec - only on init)
                            // scope.showWidget = true; // no need if there's a model watch
                        } else {
                            scope.ngModel = null;
                        }
                    }
                }
            );

            scope.$watch(
                function(scope){
                    return scope.model.addressTypeheadHelper;
                },
                function( newVal, oldVal ) {
                    if(newVal != oldVal){
                        if(angular.isObject(newVal)) {
                            const id = scope.ngModel.id;
                            const ver  = scope.ngModel.version;
                            scope.ngModel = newVal;
                            scope.ngModel.id = id;
                            scope.ngModel.prevId = id;
                            scope.ngModel.version = ver;

                            if (angular.isDefined(scope.autocompletePostUrl) && scope.autocompletePreUrl !== "" && scope.ngModel.addressId) {
                              var baseUrl = WEBAPP_PATH ;
                              $http.get(baseUrl + scope.autocompletePostUrl + '?id=' + encodeURIComponent(scope.ngModel.addressId)).then(
                                function(response){
                                  scope.ngModel = response.data;
                                });
                            }


                        }
                    }
                }
            );

        }
    };
}
addressFinder.$inject = ['$timeout',  '$templateCache', '$http'];
angular.module('app').directive('addressFinder', addressFinder);

}());

